import { render, staticRenderFns } from "./assigned-users.vue?vue&type=template&id=3b543b04&scoped=true"
import script from "./assigned-users.vue?vue&type=script&lang=js"
export * from "./assigned-users.vue?vue&type=script&lang=js"
import style0 from "./assigned-users.vue?vue&type=style&index=0&id=3b543b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b543b04",
  null
  
)

export default component.exports